var JWT_SECRET_KEY = 'xJ3h-2[Lv#';
export function createJWT(payload) {
    var header = {
        alg: 'HS256',
        typ: 'JWT',
    };
    function base64Encode(value) {
        return btoa(typeof value === 'object' ? JSON.stringify(value) : value)
            .replace(/=/g, '')
            .replace(/\+/g, '-')
            .replace(/\//g, '_');
    }
    var encodedHeader = base64Encode(header);
    var encodedPayload = base64Encode(payload);
    var signature = base64Encode(JWT_SECRET_KEY);
    return "".concat(encodedHeader, ".").concat(encodedPayload, ".").concat(signature);
}
export function decodeJWT(token) {
    function base64Decode(str) {
        return JSON.parse(atob(str.replace(/-/g, '+').replace(/_/g, '/')));
    }
    var parts = token.split('.');
    if (parts.length !== 3) {
        throw new Error('Invalid JWT Format');
    }
    try {
        var decodedHeader = base64Decode(parts[0]);
        var decodedPayload = base64Decode(parts[1]);
        return { header: decodedHeader, payload: decodedPayload };
    }
    catch (_error) {
        throw new Error('Error decoding JWT');
    }
}
